import { PublicationPropertiesController } from './publication-properties.controller'

function publicationProperties () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      data: '<',
      formProperties: '=',
      tabsLoadingData: '=',
      errors: '<',
      features: '<',
      openUpgradeCompanyPlanDialog: '&',
      selectedCampaign: '=',
      hasMultipleAssetsWithCampaign: '='
    },
    templateUrl: '/arts/directives/publication-properties/publication-properties-directive.html?$$REVISION$$',
    controller: PublicationPropertiesController
  }
}

export { publicationProperties }
